import React from "react";
import PropTypes from "prop-types";
import { InputField, RadioField, TextareaField } from "../../FormField";

const Part2 = ({ data }) => (
  <table
    style={{
      margin: "10px 0px",
      width: "100%",
      borderCollapse: "collapse",
      border: "1px solid #000",
    }}
  >
    <tbody>
      <tr>
        <td
          style={{
            fontWeight: "bold",
            backgroundColor: "#edb8be",
            paddingLeft: 10,
            borderBottom: "1px solid #000",
          }}
        >
          II)&nbsp;FAMILY HISTORY of the EMPLOYEE / ELIGIBLE MEMBER
        </td>
      </tr>
      <tr>
        <td style={{ paddingLeft: 10, borderBottom: "1px solid #000" }}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td colSpan={2}>
                  Has any of your natural parents or sibling(s) died or suffered from cancer**,
                  heart disease, stroke, high blood pressure, diabetes, kidney disease, mental
                  disorder, tuberculosis or any hereditary disease(s)?
                </td>
              </tr>
              <tr>
                <td style={{ width: 140 }}>
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <label htmlFor="EmpFamilyHistory_Yes">Yes</label>
                        </td>
                        <td>
                          <RadioField
                            name="EmpFamilyHistory"
                            {...data["EmpFamilyHistory"]}
                            style={{ marginTop: "-5px" }}
                            radioValue="Yes"
                          />
                        </td>
                        <td>
                          <label htmlFor="EmpFamilyHistory_No">No</label>
                        </td>
                        <td>
                          <RadioField
                            name="EmpFamilyHistory"
                            {...data["EmpFamilyHistory"]}
                            style={{ marginTop: "-5px" }}
                            radioValue="No"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td>
                  <span style={{ fontWeight: "bold" }}>
                    IF YES, PLEASE PROVIDE DETAILS BELOW (<sup>**</sup>
                    for CANCER, please specify the type of cancer)
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody>
              <tr>
                <td
                  colSpan={3}
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  If Alive
                </td>
                <td
                  colSpan={2}
                  style={{
                    textAlign: "center",
                    borderBottom: "1px solid #000",
                  }}
                >
                  If Deceased
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                  }}
                >
                  Relationship
                  <br />
                  (Father, mother, sister(s) or brothers(s))
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                  }}
                >
                  Please indicate type of Medical Condition and the exact Diagnosis
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                  }}
                >
                  Age at time of Diagnosis
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                  }}
                >
                  Age at Death
                </td>
                <td
                  style={{
                    textAlign: "center",
                    borderBottom: "1px solid #000",
                    verticalAlign: "bottom",
                  }}
                >
                  Cause of Death
                </td>
              </tr>
              {Array.of(1, 2, 3, 4).map(number => (
                <tr key={number} style={{ height: "60px" }}>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField
                      name={`FamilyRelationship${number}`}
                      {...data[`FamilyRelationship${number}`]}
                      style={{ width: 240 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <TextareaField
                      name={`FamilyMedicalCondition${number}`}
                      {...data[`FamilyMedicalCondition${number}`]}
                      style={{ width: 310 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField
                      name={`FamilyAgeAtDiagnosis${number}`}
                      {...data[`FamilyAgeAtDiagnosis${number}`]}
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <InputField
                      name={`FamilyAgeAtDeath${number}`}
                      {...data[`FamilyAgeAtDeath${number}`]}
                      style={{ width: 50 }}
                    />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    <TextareaField
                      name={`FamilyCauseOfDeath${number}`}
                      {...data[`FamilyCauseOfDeath${number}`]}
                      style={{ width: 310 }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
);

Part2.propTypes = {
  data: PropTypes.shape({}),
};

export default Part2;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Ge/GEHD201808/Part2.js